import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { TranslateService } from '@services/translate.service';
import { LocalizationService } from '@services/localization.service';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'left-sport-menu-dialog',
  templateUrl: '../sharedTemplates/left-sport-menu.dialog.html',
})
export class LeftSportsMenuDialog implements AfterViewInit, OnInit {
  mainData = [];
  _dayFilter = 300;
  lastReturned_dayFilter = 0;

  selectedLeagueData = [];

  constructor(
    public dialogRef: MatDialogRef<LeftSportsMenuDialog>,
    private _ApiService: ApiService,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    private _DataHelper: DataHelper,
    private _UiHelper: UiHelper
  ) {}

  backButton() {
    if (this._UiHelper.leftSportsMenuDialog) this._UiHelper.setLeftSportsMenuDialog(false);
  }

  changeDayFilter(e) {
    if (e.value == undefined) {
      return;
    }

    this._DataHelper.leftMenuSportDayFilter = e.value;
    ////console.log('changed df', this._DataHelper.leftMenuSportDayFilter);

    if (this._dayFilter != e.value) {
      e != undefined ? this.getSports(e.value) : null;
      this._dayFilter = e.value;
    }
  }

  selectedLeague(e, item2) {
    this.selectedLeagueData.find(x => x.TournamentId == e.source.value.TournamentId) == undefined
      ? this.selectedLeagueData.push(e.source.value)
      : this.selectedLeagueData.splice(
          this.selectedLeagueData.indexOf(x => x.TournamentId == e.source.value.TournamentId),
          1
        );

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    if (!e.source.checked) {
      item2.allselected = false;
    }

    ////console.log('selectedLeague');

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  selectedLeagueviaAll(e, sport, state) {
    const cbData = {
      TournamentName: e.TournamentName,
      TournamentId: e.TournamentId,
      CategoryId: e.CategoryId,
      CategoryName: e.CategoryName,
      SportId: sport.SportId,
      SportName: sport.SportName,
    };

    if (state) {
      if (this.selectedLeagueData.find(x => x.TournamentId == e.TournamentId) == undefined) {
        this.selectedLeagueData.push(cbData);
      }
    } else {
      if (this.selectedLeagueData.find(x => x.TournamentId == e.TournamentId) != undefined) {
        this.selectedLeagueData.splice(
          this.selectedLeagueData.indexOf(x => x.TournamentId == e.TournamentId),
          1
        );
      }
    }
  }

  selectAll(e, cntrl, sport) {
    ////console.log('Select All : ', e);
    e.level.forEach(cb => {
      cb.checked = cntrl.source.checked;
      this.selectedLeagueviaAll(cb, sport, cntrl.source.checked);
    });

    this._DataHelper.setLeagueData(this.selectedLeagueData);
  }

  getSports(__dayFilter = 300) {
    if (this.lastReturned_dayFilter != __dayFilter || this.lastReturned_dayFilter == 0) {
      this._ApiService
        .getSports(__dayFilter)
        .then(x => {
          this.mainData = x.map(x => {
            x['level'] = [];
            x['loading'] = false;
            x['state'] = false;
            return x;
          });
          this.lastReturned_dayFilter = __dayFilter;
        })
        .catch(err => console.log('left-sport-menu.dialog', err));
    }
  }

  getCountriesBySportsID(_sportID, _index) {
    ////console.log(this.mainData[_index].level.length);
    if (this.mainData[_index].level.length == 0 && !this.mainData[_index].state) {
      this.mainData[_index]['loading'] = true;
      this._ApiService.getCountriesBySportsID(this._dayFilter, _sportID).then(x => {
        this.mainData[_index].level = x.map(x => {
          x['level'] = [];
          x['state'] = false;
          x['loading'] = false;
          x['allselected'] = false;
          return x;
        });
        this.mainData[_index]['loading'] = false;
        this.mainData[_index]['state'] = true;
      });
    } else if (this.mainData[_index].level.length != 0 && !this.mainData[_index].state) {
      this.mainData[_index]['state'] = true;
    } else {
      this.mainData[_index]['state'] = false;
    }
    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  getTourementsByCountryID(_sportID, _countriesID, _index, _indexl2) {
    const currentItem = this.mainData[_index].level[_indexl2];
    ////console.log(currentItem);
    ////console.log(currentItem.level.length == 0, !currentItem.state);
    if (currentItem.level.length == 0 && !currentItem.state) {
      currentItem['loading'] = true;
      this._ApiService
        .getTourementsByCountryID(this._dayFilter, _sportID, _countriesID)
        .then(x => {
          currentItem.level = x.map(x => {
            x['checked'] = false;
            return x;
          });
          currentItem['loading'] = false;
          currentItem['state'] = true;
          currentItem['allselected'] = false;
          this._ApiService.getOutrightsByCountryID(this._dayFilter, _sportID, _countriesID).then(x => {
            currentItem.outrights = x.map(x => {
              x['checked'] = false;
              return x;
            });
          });
        })
        .catch(err => {
          console.log('left-sports-menu.dialog', err);
        });
    } else if (currentItem.level.length != 0 && !currentItem.state) {
      currentItem['state'] = true;
    } else {
      currentItem['state'] = false;
    }
    this.mainData[_index].level[_indexl2] = currentItem;
    ////console.log(this.mainData);
    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  ngAfterViewInit() {
    this._TranslateService.instant('home_live');
    ////console.log(this._TranslateService.instant('home_live'));

    if (this._DataHelper.LeagueData != undefined) {
      this.selectedLeagueData = this._DataHelper.LeagueData;
    }
    this._dayFilter = this._DataHelper.leftMenuSportDayFilter;

    this.changeDayFilter({ source: null, value: '300' });
  }

  ngOnInit() {
    ////console.log(this._DataHelper.leftMenuSportData != undefined);
    this._DataHelper.leftMenuSportData != undefined ? (this.mainData = this._DataHelper.leftMenuSportData) : this.getSports();
  }

  onOKClick(): void {
    this.dialogRef.close();
  }
}
